export const GET_FLASHSALES = "GET_FLASHSALES";
export const GET_FLASHSALE = "GET_FLASHSALE";